import React from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";

const RoleDescriptionList = ({ sx = {} }) => {
    const { t } = useTranslation(["role"]);

    const descriptions = t("RoleDescription", { returnObjects: true });

    return (
        <Box sx={{ mt: 0, ...sx }}>
            <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                {t("RoleDescriptionTitle", "Popis rolí / Role Descriptions")}
            </Typography>

            {Object.entries(descriptions).map(([key, value]) => (
                <Accordion
                    key={key}
                    disableGutters
                    sx={{
                        bgcolor: '#f9f9f9',
                        boxShadow: 'none',
                        borderRadius: 1,
                        mb: 1
                    }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2, py: 0 }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {t(key)}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ px: 2, pt: 0, pb: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            {value}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};

export default RoleDescriptionList;